// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"5491da23","453":"bc37fbc3"}[chunkId] + ".chunk.js";
};